import { render, staticRenderFns } from "./creditChina.vue?vue&type=template&id=728ec13e&scoped=true&"
import script from "./creditChina.vue?vue&type=script&lang=js&"
export * from "./creditChina.vue?vue&type=script&lang=js&"
import style0 from "./creditChina.vue?vue&type=style&index=0&id=728ec13e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ec13e",
  null
  
)

export default component.exports